import { Button, Text } from '@user-portal/wikr-components';
import React from 'react';
import { Trans } from 'react-i18next';

import { IDiscountOfferProps } from './types';

import * as S from './styled';

const DiscountOffer = ({
    badgeText,
    extraText,
    badgeBackgroundColor,
    oldPrice,
    period,
    periodTitle,
    isNewOffer = false,
    currencySign,
    price,
    handleSubmit,
    submitButton,
    isLoading,
    isCurrentSubscriptionMain = false,
}: IDiscountOfferProps) => {
    return (
        <S.Container $mb={24}>
            <S.Badge $backgroundColor={badgeBackgroundColor}>
                <Text color="on-primary" medium center>
                    {badgeText}
                </Text>
            </S.Badge>
            <S.Details $paddingTop={20} $paddingX={16} $paddingBottom={16} $backgroundColor="surface-default">
                {isCurrentSubscriptionMain && (
                    <Text type="small-button" center mb={20}>
                        {periodTitle}
                    </Text>
                )}
                {oldPrice && (
                    <S.CrossedText type="large-text" medium color="text-secondary" center mb={8}>
                        <Trans
                            i18nKey="subscription.cancellation.specialOffer.oldPricePeriodCrossed"
                            values={{ currencySign, price: oldPrice, period }}
                        />
                    </S.CrossedText>
                )}
                <Text type="h2" medium center mb={isNewOffer ? 20 : 0}>
                    <S.PriceWithPeriod>
                        <Trans
                            i18nKey="subscription.cancellation.specialOffer.newPricePeriod"
                            values={{ currencySign, price, period }}
                            components={{
                                SmallCurrency: <S.SmallCurrency />,
                                BigPrice: <S.BigPrice />,
                                span: <S.Period />,
                            }}
                        />
                    </S.PriceWithPeriod>
                </Text>
                {isNewOffer && (
                    <>
                        <Text type="caption" center mb={20}>
                            {extraText}
                        </Text>
                        <Button
                            onClick={handleSubmit}
                            dataLocator="discountOfferChangePlanButton"
                            isLoading={isLoading}
                        >
                            {submitButton}
                        </Button>
                    </>
                )}
            </S.Details>
        </S.Container>
    );
};

export default DiscountOffer;
